import { render } from "./course-filter.vue?vue&type=template&id=31cfc270"
import script from "./course-filter.vue?vue&type=script&lang=js"
export * from "./course-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__